import React, { useState, useRef, useCallback } from "react";
import { ReactComponent as DropdownDownIcon } from "../../../common/assets/dropdown-iterative-down.svg";
import { ReactComponent as DropdownUpIcon } from "../../../common/assets/dropdown-iterative-up.svg";
import {
  StyledDropdown,
  StyledContent,
  StyledPlaceholder,
  StyledLabel,
  StyledValue,
  StyledValue01,
  StyledInteractiveIcon,
  StyledSelectopendown,
  DropDownListContainerStyled,
  DropDownListStyled,
  ListItemStyled,
} from "./MissionListActions.styles";

interface OptionType {
  label: string;
  value: string;
}

interface StyledDropdownProps {
  label: string;
  options: OptionType[];
  value: string;
  onChange: (value: OptionType) => void;
  width?: string | number;
}

export const MissionListSortByDropdown: React.FC<StyledDropdownProps> = ({
  label,
  options,
  value,
  onChange,
  width,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleToggle = () => setIsOpen((open) => !open);
  const handleSelect = (option: OptionType) => {
    onChange(option);
    setIsOpen(false);
  };
  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  }, []);

  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, handleClickOutside]);

  const selected = options.find((opt) => opt.value === value);

  return (
    <StyledDropdown style={width ? { width } : {}} ref={ref}>
      <StyledContent onClick={handleToggle}>
        <StyledPlaceholder>
          <StyledLabel>{label}</StyledLabel>
        </StyledPlaceholder>
        <StyledValue>
          <StyledValue01>{selected ? selected.label : ""}</StyledValue01>
        </StyledValue>
      </StyledContent>
      <StyledInteractiveIcon onClick={handleToggle}>
        <StyledSelectopendown>
          {isOpen ? <DropdownUpIcon /> : <DropdownDownIcon />}
        </StyledSelectopendown>
      </StyledInteractiveIcon>
      {isOpen && (
        <DropDownListContainerStyled>
          <DropDownListStyled>
            {options.map((option) => (
              <ListItemStyled
                key={option.value}
                onClick={() => handleSelect(option)}
                style={{
                  fontWeight: option.value === value ? "bold" : "normal",
                }}
              >
                {option.label}
              </ListItemStyled>
            ))}
          </DropDownListStyled>
        </DropDownListContainerStyled>
      )}
    </StyledDropdown>
  );
};
